<template>
  <div>
    <div class="succeed container-fluid" v-if="mssg">
      <p>{{ $t("notification") }}</p>
      <p class="mb-2">{{ mssg }}</p>
    </div>
    <div class="errorMsg container-fluid" v-if="errorMssg">
      <p>{{ $t("notification") }}</p>
      <p class="mb-2">{{ errorMssg }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotifcationBox",
  props: {
    mssg: String,
    errorMssg: String,
  },
  //   watch:{
  //       mssg:{
  //           handler:function(){

  //           }
  //       }
  //   }
};
</script>

<style>
.succeed {
  background: #dee2eb;
  padding: 10px 15px 1px;
  /* border: 1px solid #213e7a; */
  margin-bottom: 2rem;
}
.succeed p {
  color: #213e7a;
}
.errorMsg {
  background: #f8e2ea;
  padding: 10px 15px 1px;
  /* border: 1px solid #a8286f; */
  margin-bottom: 2rem;
}
.errorMsg p {
  color: #a8286f;
}
</style>
